import { OrderBook } from './components/OrderBook'
import './App.scss';

function App() {
  return (
    <div className="App">
      <OrderBook />
    </div>
  );
}

export default App
